<!-- CustomSearchFilter.vue -->

<template>
  <div>
    <!-- Your custom search bar UI elements go here -->
    <input
      type="text"
      v-model="searchText"
      @keyup.enter="onSearch"
      :placeholder="$t('search')"
      class="justify-content-end align-self-center customgrid-search-bar"
    />
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  data() {
    return {
      searchText: "",
    };
  },
  props: {
    columnHeader: String,
    onCustomEvent: Function,
  },
  created() {
    eventBus.$on("clear-filters", this.clearFilters);
  },
  mounted() {
    const columnHeader = this.params.columnHeader;
    if (
      columnHeader === "eventNumber" &&
      sessionStorage.getItem("eventNumber")
    ) {
      this.searchText = sessionStorage.getItem("eventNumber");
    } else if (
      columnHeader === "eventNumberEvent" &&
      sessionStorage.getItem("eventNumberEvent")
    ) {
      this.searchText = sessionStorage.getItem("eventNumberEvent");
    } else if (
      columnHeader === "trainingname" &&
      sessionStorage.getItem("trainingname")
    ) {
      this.searchText = sessionStorage.getItem("trainingname");
    } else if (
      columnHeader === "eventTrainingCategoryName" &&
      sessionStorage.getItem("eventTrainingCategoryName")
    ) {
      this.searchText = sessionStorage.getItem("eventTrainingCategoryName");
    } else if (
      columnHeader === "vehicleType" &&
      sessionStorage.getItem("vehicleType")
    ) {
      this.searchText = sessionStorage.getItem("vehicleType");
    } else if (
      columnHeader === "locationFormatted" &&
      sessionStorage.getItem("locationFormatted")
    ) {
      this.searchText = sessionStorage.getItem("locationFormatted");
    } else if (
      columnHeader === "eventNumberEventInactive" &&
      sessionStorage.getItem("eventNumberEventInactive")
    ) {
      this.searchText = sessionStorage.getItem("eventNumberEventInactive");
    } else if (
      columnHeader === "trainingnameInactive" &&
      sessionStorage.getItem("trainingnameInactive")
    ) {
      this.searchText = sessionStorage.getItem("trainingnameInactive");
    } else if (
      columnHeader === "eventTrainingCategoryNameInactive" &&
      sessionStorage.getItem("eventTrainingCategoryNameInactive")
    ) {
      this.searchText = sessionStorage.getItem(
        "eventTrainingCategoryNameInactive"
      );
    } else if (
      columnHeader === "vehicleTypeInactive" &&
      sessionStorage.getItem("vehicleTypeInactive")
    ) {
      this.searchText = sessionStorage.getItem("vehicleTypeInactive");
    } else if (
      columnHeader === "locationFormattedInactive" &&
      sessionStorage.getItem("locationFormattedInactive")
    ) {
      this.searchText = sessionStorage.getItem("locationFormattedInactive");
    } else if (
      columnHeader === "billNumber" &&
      sessionStorage.getItem("billNumber")
    ) {
      this.searchText = sessionStorage.getItem("billNumber");
    } else if (
      columnHeader === "invoiceAmount" &&
      sessionStorage.getItem("invoiceAmount")
    ) {
      this.searchText = sessionStorage.getItem("invoiceAmount");
    } else if (
      columnHeader === "offerAmount" &&
      sessionStorage.getItem("offerAmount")
    ) {
      this.searchText = sessionStorage.getItem("offerAmount");
    } else if (
      columnHeader === "offerNumber" &&
      sessionStorage.getItem("offerNumber")
    ) {
      this.searchText = sessionStorage.getItem("offerNumber");
    } else if (
      columnHeader === "debtorNumber" &&
      sessionStorage.getItem("debtorNumber")
    ) {
      this.searchText = sessionStorage.getItem("debtorNumber");
    } else if (
      columnHeader === "trainingnameSales" &&
      sessionStorage.getItem("trainingnameSales")
    ) {
      this.searchText = sessionStorage.getItem("trainingnameSales");
    }
  },
  methods: {
    clearFilters() {
      this.searchText = "";
      const columnHeader = this.params.columnHeader;

      if (columnHeader == "eventNumber") {
        sessionStorage.removeItem("eventNumber");
      }

      if (columnHeader == "eventNumberEvent") {
        sessionStorage.removeItem("eventNumberEvent");
      }

      if (columnHeader == "trainingname") {
        sessionStorage.removeItem("trainingname");
      }

      if (columnHeader == "eventTrainingCategoryName") {
        sessionStorage.removeItem("eventTrainingCategoryName");
      }

      if (columnHeader == "vehicleType") {
        sessionStorage.removeItem("vehicleType");
      }

      if (columnHeader == "locationFormatted") {
        sessionStorage.removeItem("locationFormatted");
      }

      if (columnHeader == "eventNumberEventInactive") {
        sessionStorage.removeItem("eventNumberEventInactive");
      }

      if (columnHeader == "trainingnameInactive") {
        sessionStorage.removeItem("trainingnameInactive");
      }

      if (columnHeader == "eventTrainingCategoryNameInactive") {
        sessionStorage.removeItem("eventTrainingCategoryNameInactive");
      }

      if (columnHeader == "vehicleTypeInactive") {
        sessionStorage.removeItem("vehicleTypeInactive");
      }

      if (columnHeader == "locationFormattedInactive") {
        sessionStorage.removeItem("locationFormattedInactive");
      }

      if (columnHeader == "billNumber") {
        sessionStorage.removeItem("billNumber");
      }

      if (columnHeader == "invoiceAmount") {
        sessionStorage.removeItem("invoiceAmount");
      }

      if (columnHeader == "offerAmount") {
        sessionStorage.removeItem("offerAmount");
      }

      if (columnHeader == "offerNumber") {
        sessionStorage.removeItem("offerNumber");
      }
      if (columnHeader == "debtorNumber") {
        sessionStorage.removeItem("debtorNumber");
      }
      if (columnHeader == "trainingnameSales") {
        sessionStorage.removeItem("trainingnameSales");
      }
    },
    onSearch() {
      const searchText = this.searchText;
      const columnHeader = this.params.columnHeader;
      // inactive events
      if (columnHeader === "eventTrainingCategoryNameInactive") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem(
            "eventTrainingCategoryNameInactive",
            searchText
          );
        } else {
          sessionStorage.removeItem("eventTrainingCategoryNameInactive");
        }
      }

      if (columnHeader === "vehicleTypeInactive") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("vehicleTypeInactive", searchText);
        } else {
          sessionStorage.removeItem("vehicleTypeInactive");
        }
      }

      if (columnHeader === "locationFormattedInactive") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("locationFormattedInactive", searchText);
        } else {
          sessionStorage.removeItem("locationFormattedInactive");
        }
      }

      if (columnHeader === "trainingnameInactive") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("trainingnameInactive", searchText);
          sessionStorage.removeItem("eventNumberEventInactive");
        } else {
          sessionStorage.removeItem("trainingnameInactive");
        }
      }

      if (columnHeader === "eventNumberEventInactive") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("eventNumberEventInactive", searchText);
          sessionStorage.removeItem("trainingnameInactive");
        } else {
          sessionStorage.removeItem("eventNumberEventInactive");
        }
      }
      // active events
      if (columnHeader === "eventTrainingCategoryName") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("eventTrainingCategoryName", searchText);
        } else {
          sessionStorage.removeItem("eventTrainingCategoryName");
        }
      }

      if (columnHeader === "vehicleType") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("vehicleType", searchText);
        } else {
          sessionStorage.removeItem("vehicleType");
        }
      }

      if (columnHeader === "locationFormatted") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("locationFormatted", searchText);
        } else {
          sessionStorage.removeItem("locationFormatted");
        }
      }

      if (columnHeader === "trainingname") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("trainingname", searchText);
        } else {
          sessionStorage.removeItem("trainingname");
        }
      }

      if (columnHeader === "eventNumberEvent") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("eventNumberEvent", searchText);
        } else {
          sessionStorage.removeItem("eventNumberEvent");
        }
      }

      // set session storage
      if (columnHeader === "eventNumber") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("eventNumber", searchText);
        } else {
          sessionStorage.removeItem("eventNumber");
        }
      }

      if (columnHeader === "billNumber") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("billNumber", searchText);
        } else {
          sessionStorage.removeItem("billNumber");
        }
      }

      if (columnHeader === "invoiceAmount") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("invoiceAmount", searchText);
        } else {
          sessionStorage.removeItem("invoiceAmount");
        }
      }

      if (columnHeader === "offerAmount") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("offerAmount", searchText);
        } else {
          sessionStorage.removeItem("offerAmount");
        }
      }

      if (columnHeader === "offerNumber") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("offerNumber", searchText);
        } else {
          sessionStorage.removeItem("offerNumber");
        }
      }

      if (columnHeader === "debtorNumber") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("debtorNumber", searchText);
        } else {
          sessionStorage.removeItem("debtorNumber");
        }
      }

      if (columnHeader === "trainingnameSales") {
        if (searchText && searchText.trim() !== "") {
          sessionStorage.setItem("trainingnameSales", searchText);
        } else {
          sessionStorage.removeItem("trainingnameSales");
        }
      }

      this.$parent.$listeners.onFilterChanged(columnHeader, searchText);
    },
  },
};
</script>
